import { render } from "./RegisterPatientPage.vue?vue&type=template&id=14e4041f&ts=true"
import script from "./RegisterPatientPage.vue?vue&type=script&lang=ts"
export * from "./RegisterPatientPage.vue?vue&type=script&lang=ts"

import exportComponent from "/Volumes/DATA/Project/WebsiteProject/DanhGia_FE/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__